import { render } from "./lists.vue?vue&type=template&id=273aca3d"
import script from "./lists.js?vue&type=script&lang=js"
export * from "./lists.js?vue&type=script&lang=js"

import "./lists.vue?vue&type=style&index=0&id=273aca3d&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__